// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 76) return "static/chunks/common-7194b4992178a030.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"634":"gsap","923":"8e095c31"}[chunkId] || chunkId) + "." + {"483":"406284ddd6fb29bc","536":"06169b84adba93dd","634":"664fe33049805469","923":"a448f18f4b7fbd10"}[chunkId] + ".js";
};